// extracted by mini-css-extract-plugin
export default {"change-lesson-modal":"changeLessonModal_change-lesson-modal__VShXo","change-lesson-modal--full":"changeLessonModal_change-lesson-modal--full__LC7Be"};